// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>2</span>&nbsp;&nbsp;Out of Zion, perfect in beauty, God shines forth;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;our God comes and will not keep silence.<br> </p> </div></div>";
// Exports
module.exports = code;